export function useAuthRedirect() {
  const redirectToSavedLocation = () => {
    // URLSearchParams already decodes the query parameter once.
    const returnTo = new URLSearchParams(window.location.search).get("returnTo");
    if (!returnTo || !returnTo.startsWith("/") || returnTo.startsWith("//")) {
      return "/";
    }

    try {
      const target = new URL(returnTo, window.location.origin);
      const pathname = decodeURIComponent(target.pathname);
      const hasUnsafeCharacters = (value: string) =>
        value.includes("\\") || [...value].some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127);

      if (
        target.origin !== window.location.origin ||
        hasUnsafeCharacters(returnTo) ||
        hasUnsafeCharacters(pathname) ||
        pathname.startsWith("//") ||
        pathname.startsWith("/auth")
      ) {
        return "/";
      }

      return `${target.pathname}${target.search}${target.hash}`;
    } catch {
      return "/";
    }
  };

  return { redirectToSavedLocation };
}
